module.exports = __webpack_public_path__ + "static/media/PC3-1.f74f76f3.jpg";